import { render } from "./ProductosFoco.vue?vue&type=template&id=36e11b18"
import script from "./ProductosFoco.vue?vue&type=script&lang=js"
export * from "./ProductosFoco.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__